import { SimpleError } from '@common/errors';
import { PatchMap } from '../classes/Patchable.js';
/** Decodes incremental map changes; MapDecoder decodes full dictionary values. */
export class PatchMapDecoder {
    keyDecoder;
    valueDecoder;
    constructor(keyDecoder, valueDecoder) {
        this.keyDecoder = keyDecoder;
        this.valueDecoder = valueDecoder;
    }
    decode(container) {
        const data = container.field('changes');
        if (typeof data.value === 'object' && data.value !== null) {
            const map = new PatchMap();
            for (const key of Object.keys(data.value)) {
                const keyDecoded = data.clone({
                    data: key,
                    context: data.context,
                    field: data.addToCurrentField(key),
                }).decode(this.keyDecoder);
                const valueDecoded = data.field(key).decode(this.valueDecoder);
                map.set(keyDecoded, valueDecoded);
            }
            return map;
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected an object at ${data.currentField}`,
            field: data.currentField,
        });
    }
    isDefaultValue(value) {
        return value instanceof PatchMap && value.size === 0;
    }
    getDefaultValue() {
        return new PatchMap();
    }
}
//# sourceMappingURL=PatchMapDecoder.js.map